var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoOnlyNrz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009DDF",
    d: "M.386 50.882C27.66 64.391 54.26 39.316 80.548 50.88l.041 16.907-40.1 23.137L.427 67.786.386 50.882z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10458C",
    d: "M48.597 41.622c.852 3.04 5.098 4.508 9.484 3.28 4.383-1.229 7.248-4.689 6.396-7.732-.855-3.04-5.1-4.505-9.483-3.279-4.387 1.228-7.249 4.692-6.397 7.731"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10458C",
    d: "M73.494 31.287C46.478 11.397 34.374 42.52 6.856 46.038c12.608 4.314 25.321 1.353 37.91-1.133-.484-.677-.87-1.415-1.098-2.227-1.42-5.062 3.152-10.771 10.211-12.75a18.11 18.11 0 0 1 3.136-.581c4.363-.546 9.134.567 14.878 4.527.708.49 1.686.203 2.126-.514.444-.714.154-1.583-.525-2.073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E42828",
    d: "M80.589 5.383C68.719 2.463 55.047.798 40.489.798S12.257 2.462.388 5.383H.385v32.125C24.106 45.964 43.177-.368 80.59 31.87l-.04-26.486h.04z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyNrz);
export default __webpack_public_path__ + "static/media/logo_only_nrz.d0aac4bb27898e53001ca868b5eb731a.svg";
export { ForwardRef as ReactComponent };